import script from "./EmiratesBenefitsModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EmiratesBenefitsModal.vue?vue&type=script&setup=true&lang=js"

import "./EmiratesBenefitsModal.vue?vue&type=style&index=0&id=00ffc369&lang=scss"

const __exports__ = script;

export default __exports__